<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" role="doc-chapter">
<figure class="figure" id="fig1">
<p class="figh"><span aria-label="viii" class="page" id="pviii" role="doc-pagebreak"></span><img alt="" height="600" src="images/chi-gunn-fig001-new.jpeg" width="502"/></p>
<p class="figh"><span class="fighn">Figure 1.</span> Artist Mitch O’Connell’s <i>Alien Trump.</i> Courtesy of Mitch O’Connell.</p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gunn-0009.vue?00809e84